import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getWish } from "../../store/actions/wishs_action";
import Spinner from "../../components/layout/Spinner";
import { inputFields } from "../../shared/enums/wishs_enum";
import SingleView from "../../components/common/SingleView";
const ViewWish = ({ getWish, match, wish: { loading, wish } }) => {
  useEffect(() => {
    getWish(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Wishs"
          mainLinkTitle="Wishs"
          mainLinkUrl="/wishs"
          activeLink="View"
        />
        {!loading ? (
          wish && (
            <SingleView
              data={wish}
              inputFields={inputFields}
              label="Wish"
              link="wishs"
              id={wish.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ wish: state.wish });

const mapDispatchToProps = { getWish };

export default connect(mapStateToProps, mapDispatchToProps)(ViewWish);
